import React from 'react';
import { StyledInboxAction } from './customer.style';

/**
 * Showroom header "Inbox" entry point. Opens the customer card slideout directly on the OCC
 * Customer Inbox tab (Manager View parity). Hidden when `isVisible` is false (e.g. business customer).
 */
const CustomerInbox: React.FC<{ onClick: () => void; isVisible: boolean; label: string }> = ({ onClick, isVisible, label }) => {
    if (!isVisible) {
        return null;
    }

    return (
        <StyledInboxAction
            forwardedAs="button"
            size="xsmall"
            weight="semibold"
            data-testid="showroom-header-inbox"
            onClick={onClick}
        >
            {label}
        </StyledInboxAction>
    );
};

export default CustomerInbox;
